export default "__VITE_ASSET__7ztyH4kA__"